import React, { FC } from 'react';
import { PublicJobDetailBox } from '../../../../../../../ReactSharedScripts/modules/publicJob/detail/components/PublicJobDetailBox';
import { usePublicJobDetailDataQuery } from '../../../../../../../ReactSharedScripts/modules/publicJob/detail/hooks';
import { FlexGrid } from '../../../../../../../ReactSharedScripts/components/FlexGrid';
import { PublicJobDetailApply } from '../../../../../../../ReactSharedScripts/modules/publicJob/detail/components/PublicJobDetailApply';
import { PublicJobDetailShare } from '../../../../../../../ReactSharedScripts/modules/publicJob/detail/components/PublicJobDetailShare';
import { isNull } from '../../../../../../../ReactSharedScripts/predicates/type';
import { PublicJobDetailTags } from '../../../../../../../ReactSharedScripts/modules/publicJob/detail/components/PublicJobDetailTags';
import { PublicJobDetailSkills } from '../../../../../../../ReactSharedScripts/modules/publicJob/detail/components/PublicJobDetailSkills';
import { PublicJobSubscription } from '../../../../../../../ReactSharedScripts/modules/publicJob/components/PublicJobSubscription';
import { useUserPageContextState } from '../../../../../../../ReactSharedScripts/modules/user';
import { PublicJobDetailEmployer } from '../../../../../../../ReactSharedScripts/modules/publicJob/detail/components/PublicJobDetailEmployer';
import { PublicJobDetailContact } from '../../../../../../../ReactSharedScripts/modules/publicJob/detail/components/PublicJobDetailContact';

export const PublicJobDetailSidebar: FC = () => {
	const { isAuthenticated } = useUserPageContextState();
	const {
		data: { isExpired, tags, skills, employer, jobContact, alertSubscription },
	} = usePublicJobDetailDataQuery();

	return (
		<FlexGrid
			gap='small'
			column
		>
			{!isExpired && <PublicJobDetailApply />}
			<PublicJobDetailShare />
			{!isNull(tags) && <PublicJobDetailTags />}
			{!isNull(skills) && <PublicJobDetailSkills />}
			{!isAuthenticated && (
				<PublicJobDetailBox>
					<PublicJobSubscription
						recaptchaPublicKey={
							isNull(alertSubscription) ? undefined : alertSubscription.recaptchaPublicKey
						}
					/>
				</PublicJobDetailBox>
			)}
			{!isNull(employer) && <PublicJobDetailEmployer />}
			{!isNull(jobContact) && <PublicJobDetailContact />}
		</FlexGrid>
	);
};
